export default __webpack_public_path__ + "2a6aa57e2f34aed45d553f1d78560c9a.png";